import {ReactComponent as WalletIcon} from './wallet.svg'

function Wallet() {
  return <WalletIcon />
}

export default Wallet
